import { RPCClient } from '@buffer-mono/legacy-rpc-utils'

const rpc = new RPCClient({
  url: '/rpc',
  sendCredentials: 'same-origin',
})

export default rpc
